import brand from "../../../../src/projects/exquisite-corpse-club/images/brand/type-color-panels.svg";
import icons from "../../../../src/projects/exquisite-corpse-club/images/brand/icons-cursor.svg";
import * as React from 'react';
export default {
  brand,
  icons,
  React
};